import React from 'react'
import { motion } from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

const { FiAlertTriangle, FiTrash2, FiX } = FiIcons

const DeleteConfirmation = ({ title, message, onConfirm, onCancel, loading }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4"
      onClick={onCancel}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm w-full mx-auto"
        onClick={e => e.stopPropagation()}
      >
        <div className="text-center mb-6">
          <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiAlertTriangle} className="text-3xl text-red-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-900">{title || 'Confirm Delete'}</h2>
          <p className="text-gray-600 mt-2 text-sm leading-relaxed">
            {message || 'Are you sure you want to delete this? This action cannot be undone.'}
          </p>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 bg-gray-100 text-gray-700 py-3 px-4 rounded-xl hover:bg-gray-200 transition-all font-semibold flex items-center justify-center space-x-2"
          >
            <SafeIcon icon={FiX} />
            <span>Cancel</span>
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 bg-red-600 text-white py-3 px-4 rounded-xl hover:bg-red-700 transition-all font-semibold shadow-lg shadow-red-200 flex items-center justify-center space-x-2"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            ) : (
              <>
                <SafeIcon icon={FiTrash2} />
                <span>Delete</span>
              </>
            )}
          </button>
        </div>
      </motion.div>
    </motion.div>
  )
}

export default DeleteConfirmation